const sectionCompareTwoImgCss = `
[data-type='section-compare-two-img'] [data-attribute='card-container'] {
  padding: 40px 0;
}

[data-type='section-compare-two-img'] .wrap-card {
  display: flex;
  flex-wrap: wrap;
  gap: 50px;
}

[data-type='section-compare-two-img'] .wrap-card .card-left {
  width: calc((100% - 50px) / 2);
  display: flex;
  flex-direction: column;
  justify-content: center;
}

[data-type='section-compare-two-img'] .wrap-card .card-left .wrap-text h1,
[data-type='section-compare-two-img'] .wrap-card .card-left .wrap-text h2,
[data-type='section-compare-two-img'] .wrap-card .card-left .wrap-text h3 {
  font-size: 24px;
}

[data-type='section-compare-two-img'] .wrap-card .card-right {
  width: calc((100% - 50px) / 2);
}

[data-type='section-compare-two-img'] .wrap-card .card-right .img-comp-container {
  width: 100%;
  aspect-ratio: 1/1;
  position: relative;
}

[data-type='section-compare-two-img'] .wrap-card .card-right .img-comp-container .img-comp-img {
  position: absolute;
  width: 100%;
  height: 100%;
  overflow: hidden;
}

[data-type='section-compare-two-img'] .wrap-card .card-right .img-comp-container .img-comp-img img {
  pointer-events: none;
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: top left;
  margin: 0;
  border: none;
  display: block;
}

[data-type='section-compare-two-img'] .wrap-card .card-right .img-comp-container .img-comp-slider {
  position: absolute;
  z-index: 9;
  cursor: ew-resize;
  width: 6px;
  height: 100%;
  background-color: #fff;
}

[data-type='section-compare-two-img'] .wrap-card .card-right .img-comp-container .img-comp-slider::after {
  position: absolute;
  content: '';
  width: 10px;
  height: 15px;
  top: 50%;
  left: 0px;
  transform: translate(-20px, -50%);
  clip-path: polygon(100% 0%, 0 50%, 100% 100%);
  display: block !important;
  background-color: #fff;
}

[data-type='section-compare-two-img'] .wrap-card .card-right .img-comp-container .img-comp-slider::before {
  position: absolute;
  content: '';
  width: 10px;
  height: 15px;
  top: 50%;
  right: 0;
  transform: translate(20px, -50%);
  clip-path: polygon(100% 50%, 0 0, 0 100%);
  display: block !important;
  background-color: #fff;
}

[data-type='section-compare-two-img'] .wrap-card .card-right .img-comp-container .before-and-after .before {
  position: absolute;
  top: 0;
  left: 0;
  padding: 0 10px;
}

[data-type='section-compare-two-img'] .wrap-card .card-right .img-comp-container .before-and-after .after {
  position: absolute;
  top: 0;
  right: 0;
  padding: 0 10px;
}

@container (max-width: 768px) {
  [data-type='section-compare-two-img'] [data-attribute='card-container'] {
    padding: 16px 0;
  }

  [data-type='section-compare-two-img'] .wrap-card {
    gap: 20px;
  }

  [data-type='section-compare-two-img'] .wrap-card .card-left {
    width: 100%;
    order: 1 !important;
    justify-content: center;
  }

  [data-type='section-compare-two-img'] .wrap-card .card-left .wrap-text {
    text-align: center;
  }

  [data-type='section-compare-two-img'] .wrap-card .card-left .wrap-text h1,
  [data-type='section-compare-two-img'] .wrap-card .card-left .wrap-text h2,
  [data-type='section-compare-two-img'] .wrap-card .card-left .wrap-text h3 {
    font-size: 16px;
  }

  [data-type='section-compare-two-img'] .wrap-card .card-right {
    width: 100%;
  }
}
`;

export default sectionCompareTwoImgCss;
